























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateAnnualManagementPlan from "./create-annualmanagementplan.vue";
import EditAnnualManagementPlan from "./edit-annualmanagementplan.vue"; 
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  status: 2; //nullable
  enterpriseinformationid:number;
   
}


 @Component({
        components:{CreateAnnualManagementPlan,EditAnnualManagementPlan}
    })
export default class AnnualManagementPlan extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();


  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
                   
    return this.$store.state.annualmanagementplan.list;
  }
  get loading() {
    return this.$store.state.annualmanagementplan.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("annualmanagementplan/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("annualmanagementplan/setPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    if(this.pagerequest.status==undefined){
      this.pagerequest.status=2;
    }
    

    await this.$store.dispatch({
      type: "annualmanagementplan/getAll",
      data: this.pagerequest,
    });
  }
     
  get pageSize() {
    return this.$store.state.annualmanagementplan.pageSize;
  }
  get totalCount() {
    return this.$store.state.annualmanagementplan.totalCount;
  }
  get currentPage() {
    return this.$store.state.annualmanagementplan.currentPage;
  }
   enterpriseinformationid

 


 
 





 
  columns = [
     {
      
      title: this.L("ID"),
      key: "id",
      width: 100,
    },
     {
      title: this.L("所属单位"),
      render: (h: any, params: any) => {
        return h("span", params.row.enterpriseInformation.corporatename);
      },
       
    } 
     ,
    {
      title: this.L("计划开始日期"),
      key: "startdate",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.startdate).toLocaleDateString('zh-cn'));
      },
       width: 200,
    },
     
    {
      title: this.L("计划结束日期"),
      key: "enddate",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.enddate).toLocaleDateString('zh-cn'));
      },
      width: 200,
    },
    


    {
    
      title: this.L("审核状态"),
       width: 100,
      render: (h: any, params: any) => {
        return h("span", params.row.status==true ? this.L("已审核") : this.L("未审核"));
      },
    },
 
    
    {
      title: this.L("审核时间"),
      key: "startustime",
      render: (h: any, params: any) => {

        var time=""
        if(params.row.startustime!=null){
          time= new Date(params.row.startustime).toLocaleString();
        }	
        if(time=="1/1/1 00:00:00"){
          time="";
        }

        return h("span", time);
      },
      width: 200,
    },
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 300,
      render: (h: any, params: any) => {
           
           var listbtn= [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("annualmanagementplan/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("详细")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteDataConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "annualmanagementplan/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ];
        if(!params.row.status){
           listbtn.push(h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              }, style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("UpdateDataApprovedConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "annualmanagementplan/updatestatus",
                        data: {aid:params.row.id},
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("审核"))  //updatestatus
          ,)

        }


        return h("div",listbtn);
      },
    },
  ];
  async created() {
     this.pagerequest.status=2;
    this.getHazardouswasteInformationAll();
    this.getpage();
    
    
    
  }

 async  getHazardouswasteInformationAll() {
   
     await this.$store.dispatch({
      type: "annualmanagementplan/getHazardouswasteInformationAll",
      data: {},
    });
  }

  /*
     async  getWastecodeAll() {
     await this.$store.dispatch({
      type: "annualmanagementplan/getWastecodeAll",
      data: {status:2},
    })
    }

     async  getEnterpriseInformationAll() {
     await this.$store.dispatch({
      type: "annualmanagementplan/getEnterpriseInformationAll",
      data: {corporatetype:2},
    });
  }*/
 

 //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "annualmanagementplan/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  item.status == false ? item.status = '否' : item.status == true ?  item.status ='是' : item.status ='否'
                        item.corporatename=item.annualmanagementplan.corporatename
          
					  return item;
					});

                    


 
         //https://blog.csdn.net/weixin_51886616/article/details/126996341
    
					const filterVal = ['id','corporatename','vehicleintype','vehicleinnumber','vehiclecolor','loadcapacity','transportnumber','status' ];// 取出要下载的表头字段
					const tHeader = ['ID','所属单位','车辆类型','车牌号','车牌颜色','载重量(kg)','运输证号','是否启用'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '车辆信息');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

			
}
